import React,  { useState, useEffect } from "react";
import { ButtonSubmitGreen, ButtonTransparent } from "../UI/Buttons/Buttons";
import { Grid, Rating } from '@mui/material';
import AuthInput from "../UI/Input/AuthInputs";
import { checkAuthenticatedUser } from "../../utils/client-functions";
import { SuccessFailureModal } from "../UI/Modal/Modal";
import axios from "axios";
import qmarkImg from '../../images/placid-q-mark.gif';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { useErrorSetter } from '../../hooks/useUiMessages';
import { setFetching } from "../../redux/states";
import { jwtDecode } from 'jwt-decode';

export const GlassModalOverlay = ({ children }) => {
    return (
        <div style={{
            backgroundColor: 'rgba(0, 0, 0, 0.65)',
            boxSizing: 'border-box',
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            width: '100vw',
            zIndex: 1100000,
            overflowY: 'scroll',
            overflowX: 'hidden',
            padding: '50px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <div style={{
                background: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                borderRadius: '24px',
                border: '1px solid rgba(255, 255, 255, 0.5)',
                boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
                boxSizing: 'border-box',
                padding: '2.5rem',
                color: '#0C1E28',
                margin: '0 auto',
                zIndex: 9999,
                textAlign: 'center',
                width: '100%',
                maxWidth: '600px',
                animation: 'bubble-pop-in 0.6s cubic-bezier(.68,-0.55,.27,1.55)'
            }}>
                {children}
            </div>
        </div>
    );
}

const Feedback = ({ origin = "jobhub", onClose }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [ratingStar, setRatingStar] = useState(0);
    const [comment, setComment] = useState("");
    const [feedbackSent, setFeedbackSent] = useState(false);
    const isAuth = localStorage?.getItem('token');
    const authUser = isAuth ? jwtDecode(isAuth) : null;
    const firstName = authUser?.name ? authUser.name.split(" ")[0] : "";

    const errorSetter = useErrorSetter();

    useEffect(() => {
        const isAuthenticated = async () => {
            try {
                await checkAuthenticatedUser();
            } catch (error) {
                return navigate("/popin?resume");
            }
        };

        isAuthenticated();
    }, [navigate]);

    const submitRating = async () => {
        if (ratingStar < 0.5) {
            return errorSetter("Rating stars please?");
        }
        try {
            dispatch(setFetching(true));
            const data = {
                name: firstName,
                rating: ratingStar,
                comment: comment,
                origin: origin
            };
            const response = await axios.post("/dashboard/submit-feedback", data, {
                headers: {
                    "x-access-token": isAuth,
                },
            });
            setFeedbackSent(true);
            localStorage.removeItem('feedbackTime');
            localStorage.setItem('token', response?.data?.token);
            if (onClose) onClose(); // Auto close if provided
        } catch (error) {
            errorSetter("Something went wrong, please try again");
        }
        dispatch(setFetching(false));
    };

    const cancelFeedback = () => {
        localStorage.removeItem('feedbackTime');
        if (onClose) {
            onClose();
        } else {
            window.location.reload();
        }
    };

    const handleCommentChange = (e) => {
        setComment(e.target.value);
    };

    return (
        <div>
            {!feedbackSent ? (
                <GlassModalOverlay>
                    <div style={{ width: '150px', margin: '0 auto 1.5rem auto' }}>
                        <img src={qmarkImg} alt='Success Feedback' style={{ width: '100%', borderRadius: '50%', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }} />
                    </div>
                    <h2 style={{ color: 'var(--navColor2)', marginBottom: '0.5rem', fontWeight: 700, fontSize: '2rem' }}>Tell us of your experience so far</h2>
                    <p style={{ fontSize: '1rem', color: '#555', marginBottom: '1.5rem' }}>Stand a chance to get ONE FREE MONTH on us. We value your feedback to constantly improve and make Bubble Ai work better for you!</p>
                    
                    <Grid container>

                        <Grid item xs={12} style={{ margin: '1rem 0' }}>
                            <Rating 
                                name="half-rating" 
                                value={ratingStar} 
                                size="large" 
                                precision={0.5}
                                onChange={(event, newValue) => {
                                    setRatingStar(newValue);
                                }} 
                                sx={{
                                    fontSize: '3rem',
                                    color: 'var(--navColor1)'
                                }}
                            />
                        </Grid>

                        <AuthInput
                            id={"comment"}
                            value={comment}
                            placeholder="Tell us what you loved or what we can do better here..."
                            multiline={true}
                            rows={3}
                            mb={2}
                            inputGridSm={12}
                            onChange={handleCommentChange}
                        />
                    </Grid>

                    <Grid container spacing={2} style={{ marginTop: '1rem' }}>
                        <Grid item xs={6}>
                            <ButtonTransparent onClick={cancelFeedback} style={{ width: '100%' }}>
                                Skip for now
                            </ButtonTransparent> 
                        </Grid>
                        <Grid item xs={6}>
                            <ButtonSubmitGreen type="button" onClick={submitRating} style={{ width: '100%', background: 'linear-gradient(45deg, var(--navColor1) 30%, var(--navColor2) 90%)', boxShadow: '0 3px 5px 2px rgba(94, 204, 211, .3)', color: 'white' }}>
                                Submit Review
                            </ButtonSubmitGreen>  
                        </Grid>
                    </Grid>
                </GlassModalOverlay>                                    
            ) : (
                <SuccessFailureModal 
                    success={true} 
                    notApaymentTextPositive="Thank you for your valuable feedback!"
                    notApayment={true}
                    buttonText="Continue"
                />
            )}
        </div>
    );
}

export default Feedback;
